export default "__VITE_ASSET__B$njRm7F__"